import { useEffect } from 'react';
import { initializeBetterBugs } from '../../utils/initialize-third-party-integrations';

interface UseBetterBugsIntegrationWithConfigProps {
  enable?: boolean;
  apiKey?: string;
  onError?: (error: any) => void;
}

const useBetterBugsIntegrationWithConfig = ({
  enable = false,
  apiKey = process.env.REACT_APP_CFG_CORE_03,
  onError,
}: UseBetterBugsIntegrationWithConfigProps = {}) => {
  useEffect(() => {
    if (!enable) return;

    try {
      if (apiKey) {
        initializeBetterBugs(apiKey);
      }
    } catch (error) {
      if (process.env.NODE_ENV === 'development') {
        // eslint-disable-next-line no-console
        console.error('Error initializing BetterBugs:', error);
      }
      onError?.(error);
    }
  }, [enable, apiKey, onError]);

  return null;
};

export default useBetterBugsIntegrationWithConfig;
